/**
 * OperatorLayout — F-007 Phase 4 (IMPL-P4-005).
 *
 * Wrapper sottile attorno ad `AppLayout` per le pagine `/operatore/*`.
 * Centralizza eventuali chrome aggiuntive (titolo, breadcrumb) senza
 * duplicare la nav-bar globale.
 */
import type { ReactNode } from 'react';
import { AppLayout } from '@/components/layout/AppLayout';

interface OperatorLayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
}

export function OperatorLayout({ children, title, description }: OperatorLayoutProps) {
  return (
    <AppLayout>
      <div className="space-y-6">
        {(title || description) && (
          <header className="space-y-1">
            {title && (
              <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
            )}
            {description && (
              <p className="text-sm text-muted-foreground">{description}</p>
            )}
          </header>
        )}
        {children}
      </div>
    </AppLayout>
  );
}
